import React from 'react';
import { Tag } from '@kaleyra/emmy';
import { IColumn } from '@kaleyra/emmy/dist/molecules/styledTable';
import i18n from '../../../../../i18n/i18n';
// import {useTranslation} from 'react-i18next';
import moment from 'moment';

import { AssetsStatusColorMap } from '../../../../../constants';

export const SmsId = (): Array<IColumn> => [
	{
		header: i18n.t('assetsWidgetSenderId'),
		accessor: 'sender_id',
		width: '40%'
	},
	{
		header: i18n.t('mainCountry'),
		accessor: 'country',
	},
	{
		header: i18n.t('assetsWidgetRequestedDate'),
		accessor: 'requested_date',
		Cell: (({ original }) => {
			return moment.unix(original.requested_date).utc().format('DD MMM YYYY');
		})
	},
	{
		header: i18n.t('assetsWidgetStatus'),
		accessor: 'status',
		Cell: ({ value }) => {
			return (
				<>
					<Tag
						label={value}
						type={(AssetsStatusColorMap as any)[value]}
					/>
				</>
			);
		},
	},
];

export const SmsTemplate = (): Array<IColumn> => [
	{
		header: i18n.t('assetsWidgetTemplateTitle'),
		accessor: 'template_title',
		width: '40%'
	},
	{
		header: i18n.t('assetsWidgetPurpose'),
		accessor: 'purpose',
	},
	{
		header: i18n.t('assetsWidgetRequestedDate'),
		accessor: 'requested_date',
		Cell: (({ original }) => {
			return moment.unix(original.requested_date).utc().format('DD MMM YYYY');
		})
	},
	{
		header: i18n.t('assetsWidgetStatus'),
		accessor: 'status',
		Cell: ({ value }) => {
			return (
				<>
					<Tag
						label={value}
						type={(AssetsStatusColorMap as any)[value]}
					/>
				</>
			);
		},
	},
];

export const DidNumber = (): Array<IColumn> => [
	{
		header: i18n.t('assetsWidgetNumber'),
		accessor: 'number',
	},
	{
		header: i18n.t('mainCountry'),
		accessor: 'country',
	},
	{
		header: i18n.t('assetsWidgetNextBillingDate'),
		accessor: 'next_billing_date',
		Cell: (({ original }) => {
			return moment.unix(original.next_billing_date).utc().format('DD MMM YYYY');
		})
	},
	{
		header: i18n.t('assetsWidgetRequestedDate'),
		accessor: 'requested_date',
		Cell: (({ original }) => {
			return moment.unix(original.requested_date).utc().format('DD MMM YYYY');
		})
	},
	{
		header: i18n.t('assetsWidgetStatus'),
		accessor: 'status',
		Cell: ({ value }) => {
			return (
				<>
					<Tag
						label={value}
						type={(AssetsStatusColorMap as any)[value]}
					/>
				</>
			);
		},
	},
];

export const WhatsappNumber = (): Array<IColumn> => [
	{
		header: i18n.t('assetsWidgetDisplayName'),
		accessor: 'display_name',
	},
	{
		header: i18n.t('assetsWidgetNumber'),
		accessor: 'number',
	},
	{
		header: i18n.t('assetsWidgetRequestedDate'),
		accessor: 'requested_date',
		Cell: (({ original }) => {
			return moment.unix(original.requested_date).utc().format('DD MMM YYYY');
		})
	},
	{
		header: i18n.t('assetsWidgetStatus'),
		accessor: 'status',
		Cell: ({ value }) => {
			return (
				<>
					<Tag
						label={value}
						type={(AssetsStatusColorMap as any)[value]}
					/>
				</>
			);
		},
	},
];

export const WhatsappTemplate = (): Array<IColumn> => [
	{
		header: i18n.t('assetsWidgetTemplateName'),
		accessor: 'template_name',
		width: '40%'
	},
	{
		header: i18n.t('assetsWidgetCategory'),
		accessor: 'category',
	},
	{
		header: i18n.t('assetsWidgetLanguage'),
		accessor: 'language',
	},
	{
		header: i18n.t('assetsWidgetRequestedDate'),
		accessor: 'requested_date',
		Cell: (({ original }) => {
			return moment.unix(original.requested_date).utc().format('DD MMM YYYY');
		})
	},
	{
		header: i18n.t('assetsWidgetStatus'),
		accessor: 'status',
		Cell: ({ value }) => {
			return (
				<>
					<Tag
						label={value}
						type={(AssetsStatusColorMap as any)[value]}
					/>
				</>
			);
		},
	},
];

export const KycDocuments = (): Array<IColumn> => [
	{
		header: i18n.t('assetsWidgetId'),
		accessor: 'id',
	},
	{
		header: i18n.t('assetsWidgetDocument'),
		accessor: 'document_name',
	},
	{
		header: i18n.t('assetsWidgetUploadDate'),
		accessor: 'upload_date',
	},
	{
		header: i18n.t('assetsWidgetStatus'),
		accessor: 'status',
		Cell: ({ value }) => {
			return (
				<>
					<Tag
						label={value}
						type={(AssetsStatusColorMap as any)[value]}
					/>
				</>
			);
		},
	},
];
export default SmsId;
